import * as yup from "yup";

import * as MESSAGES from "../messages";

export const userInfoSchema = yup.object().shape({
  role: yup.string().required(MESSAGES.REQUIRE_MESSAGE),
  industry: yup.string().required(MESSAGES.REQUIRE_MESSAGE),
  goals: yup.string().required(MESSAGES.REQUIRE_MESSAGE),
});
